// extracted by mini-css-extract-plugin
export default {"acotaciones":"TranspaisTripAcotaciones_acotaciones__FdhlE","item":"TranspaisTripAcotaciones_item__nBaiu"};